class ScrollHeader {
	constructor() {

	}

	scroll() {
		let lastScrollTop = 0;
		window.addEventListener('scroll', () => {
			let header = document.querySelector('.header .header-wrapper'),
				scroll = window.pageYOffset || document.documentElement.scrollTop,
				offset_scroll = header.dataset.scroll;

			if(scroll >= lastScrollTop) {
				header.classList.remove('fixed');

				if(scroll >= offset_scroll) {
					header.classList.add('scroll')
				} else {
					header.classList.remove('scroll');
				}

			} else {
				if(scroll <= offset_scroll) {
					header.classList.remove('fixed')
				} else {
					header.classList.add('fixed');
					header.classList.remove('scroll');
				}
			}

			lastScrollTop = scroll <= 0 ? 0 : scroll;
		})
	}
}

new ScrollHeader().scroll();